import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { API } from "../../lib/api";

export default function PaymentResult({ ok }) {
  const [params] = useSearchParams();
  const [status, setStatus] = useState(ok ? "checking" : "cancelled");
  const sessionId = params.get("session_id");

  useEffect(() => {
    if (!ok || !sessionId) return;
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await API.get(`/billing/status/${sessionId}`);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
      } catch { /* keep polling briefly */ }
      tries += 1;
      if (tries < 10) setTimeout(poll, 2000);
      else setStatus("pending");
    };
    poll();
  }, [ok, sessionId]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-100 px-4">
      <div className="card-gov w-full max-w-md p-8 text-center" data-testid="payment-result">
        {status === "checking" && (<><Loader2 className="mx-auto h-12 w-12 animate-spin text-navy" />
          <h1 className="mt-4 text-xl font-bold text-navy">Confirming your payment…</h1>
          <p className="mt-2 text-sm text-slate-500">We're verifying with Stripe. This takes a few seconds.</p></>)}
        {status === "paid" && (<><CheckCircle2 className="mx-auto h-12 w-12 text-emerald-600" />
          <h1 className="mt-4 text-xl font-bold text-navy">Subscription Active</h1>
          <p className="mt-2 text-sm text-slate-500">Your AZ Tax Accounts subscription is confirmed. Welcome aboard.</p>
          <Link to="/portal" className="btn-navy mt-6 w-full" data-testid="payment-goto-portal">Go to My Dashboard</Link></>)}
        {status === "pending" && (<><Loader2 className="mx-auto h-12 w-12 text-amber-500" />
          <h1 className="mt-4 text-xl font-bold text-navy">Payment Processing</h1>
          <p className="mt-2 text-sm text-slate-500">Your payment hasn't been confirmed yet. We'll update your account the moment Stripe confirms it — you will never be shown as paid until it's real.</p>
          <Link to="/portal/settings?tab=billing" className="btn-outline-gov mt-6 w-full">Check Billing Status</Link></>)}
        {status === "cancelled" && (<><XCircle className="mx-auto h-12 w-12 text-slate-400" />
          <h1 className="mt-4 text-xl font-bold text-navy">Checkout Cancelled</h1>
          <p className="mt-2 text-sm text-slate-500">No charge was made. You can pick a plan whenever you're ready.</p>
          <Link to="/portal/settings?tab=billing" className="btn-navy mt-6 w-full" data-testid="payment-retry">Choose a Plan</Link></>)}
      </div>
    </div>
  );
}
